<ng-container *ngIf="(formFilterFieldsService.isInitForm$ | async) === true">
    <div class="block flex-none gt-sm:grid grid-flow-row grid-cols-12 gap-2 mb-2">
        <ng-container *ngFor="let item of formFilterFieldsService.entityGrid">
            <ng-container
                *ngIf="
                    formFilterFieldsService.fieldGrid[item.name] && formFilterFieldsService.fieldGrid[item.name].length
                "
            >
                <fui-card [title]="item.title[appService.currentLanguage]" [style]="getWidthCss(item)">
                    <div class="block gt-sm:grid grid-flow-row grid-cols-12 gap-2 px-2 pb-2">
                        <ng-container *ngFor="let itemField of formFilterFieldsService.fieldGrid[item.name]">
                            <div [style]="getWidthCss(itemField)">
                                <ng-container
                                    [ngTemplateOutlet]="fieldTemplate"
                                    [ngTemplateOutletContext]="{ field: itemField, form: formDynamic }"
                                >
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </fui-card>
            </ng-container>
        </ng-container>
    </div>
</ng-container>

<ng-template #fieldTemplate let-field="field" let-form="form">
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.registry">
        <ng-container
            dynamic-field
            [field]="{
                type: 'select-search',
                label: field.title[appService.currentLanguage],
                name: field.name,
                options: registers[field.filter.scope] ? registers[field.filter.scope] : [],
                multiple: true,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <!-- Базовый доступ -->
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.access">
        <div class="flex flex-col gap-2">
            <!-- Субъект -->
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-search',
                    label:
                        field.title[appService.currentLanguage] +
                        ' (' +
                        appService.language_dictionary.system_subject +
                        ')',
                    name: 'subject',
                    options: registers['user_access_level_subject(' + field?.user_access_id + ')']
                        ? registers['user_access_level_subject(' + field?.user_access_id + ')']
                        : [],
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [group]="form.get(field.name)"
            >
            </ng-container>

            <!-- Пользователь -->
            <ng-container *ngIf="field?.is_user_bind">
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'select-search',
                        label:
                            field.title[appService.currentLanguage] +
                            ' (' +
                            appService.language_dictionary.system_user +
                            ')',
                        name: 'user',
                        options: registers['users'] ? registers['users'] : [],
                        multiple: true,
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                >
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.technicalProcess">
        <div class="flex flex-col gap-2">
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'select-search',
                        label: field.title_tp
                            ? field.title_tp[appService.currentLanguage]
                            : field.title[appService.currentLanguage],
                        name: 'tp',
                        options: field.filter.values_tp,
                        multiple: true,
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'select-search',
                        label: field.title_regulation
                            ? field.title_regulation[appService.currentLanguage]
                            : field.title[appService.currentLanguage],
                        name: 'regulation',
                        options: field.filter.values_regulation,
                        multiple: true,
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.list">
        <ng-container *ngIf="!field?.filter?.list_view_as_tree">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-search',
                    label: field.title[appService.currentLanguage],
                    name: field.name,
                    options: field.filter.values,
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [group]="form"
            ></ng-container>
        </ng-container>
        <ng-container *ngIf="field?.filter?.list_view_as_tree">
            <ng-container
                dynamic-field
                [field]="{
                    type: 'select-tree',
                    label: field.title[appService.currentLanguage],
                    name: field.name,
                    options: field.filter.values,
                    multiple: true,
                    validations: [
                        {
                            name: 'serverError',
                        },
                    ],
                }"
                [data]="{
                    isFolderSelect: true,
                    title: field.title[appService.currentLanguage],
                    treeData: field.filter.values ? field.filter.values : [],
                }"
                [group]="form"
            ></ng-container>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.string">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                mask: field.string_mask,
                regex: field.string_validation,
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.text">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.numerator">
        <ng-container
            dynamic-field
            [field]="{
                type: 'input',
                label: field.title[appService.currentLanguage],
                inputType: 'text',
                name: field.name,
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.date">
        <div class="grid grid-flow-row grid-cols-2 gap-2">
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: factorRowService.getDateType(field),
                        label:
                            field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_from,
                        name: 'from',
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                    [data]="{ maxField: 'to' }"
                ></ng-container>
            </div>
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: factorRowService.getDateType(field),
                        label: field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_to,
                        name: 'to',
                        validations: [
                            {
                                name: 'serverError',
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                    [data]="{ minField: 'from' }"
                ></ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.digit">
        <div class="grid grid-flow-row grid-cols-2 gap-2">
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'input',
                        label:
                            field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_from,
                        inputType: 'text',
                        name: 'from',
                        mask: 'integer',
                        validations: [
                            {
                                name: 'serverError',
                            },
                            {
                                name: 'max',
                                message: appService.language_dictionary.initial_value_cannot_greater_than_final,
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
            <div>
                <ng-container
                    dynamic-field
                    [field]="{
                        type: 'input',
                        label: field.title[appService.currentLanguage] + ' ' + appService.language_dictionary.system_to,
                        inputType: 'text',
                        name: 'to',
                        mask: 'integer',
                        validations: [
                            {
                                name: 'serverError',
                            },
                            {
                                name: 'min',
                                message: appService.language_dictionary.final_value_cannot_low_than_initial,
                            },
                        ],
                    }"
                    [group]="form.get(field.name)"
                ></ng-container>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.bool">
        <ng-container
            dynamic-field
            [field]="{
                type: 'select-search',
                label: field.title[appService.currentLanguage],
                name: field.name,
                options: [
                    { name: appService.language_dictionary.system_yes, id: 1 },
                    { name: appService.language_dictionary.system_no, id: 0 },
                ],
                validations: [
                    {
                        name: 'serverError',
                    },
                ],
            }"
            [group]="form"
        ></ng-container>
    </ng-container>
    <ng-container *ngIf="field.filter && field.filter.type === fieldsTypes.address">
        <fui-card [title]="field.title[appService.currentLanguage]">
            <div class="flex flex-col p-2 pt-0">
                <div>
                    <div [class.select-load-options]="isRegionLoaded">
                        <ng-container
                            [id]="field.name + '_region'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_region,
                                name: 'region',
                                options: addressData.region,
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isRegionRequested"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="24"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div>
                    <div [class.select-load-options]="isLoadAddress.district[field.name]">
                        <ng-container
                            [id]="field.name + '_district'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_district,
                                name: 'district',
                                options:
                                    addressData.district && addressData.district[field.name + '_district']
                                        ? addressData.district[field.name + '_district']
                                        : [],
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isLoadAddress.district[field.name]"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="24"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div>
                    <div [class.select-load-options]="isLoadAddress.city[field.name]">
                        <ng-container
                            [id]="field.name + '_city'"
                            dynamic-field
                            [field]="{
                                type: 'select-search',
                                label: appService.language_dictionary.address_dialog_city,
                                name: 'city',
                                options:
                                    addressData.city && addressData.city[field.name + '_city']
                                        ? addressData.city[field.name + '_city']
                                        : [],
                                multiple: true,
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                        <mat-progress-spinner
                            *ngIf="isLoadAddress.city[field.name]"
                            matSuffix
                            color="primary"
                            mode="indeterminate"
                            diameter="24"
                        ></mat-progress-spinner>
                    </div>
                </div>
                <div class="flex flex-col basis-full">
                    <div class="flex flex-row gap-2">
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_1',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                    </div>
                    <div class="flex flex-row gap-2">
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_2',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                        <div class="basis-full">
                            <ng-container
                                dynamic-field
                                [field]="{
                                    type: 'input',
                                    label: appService.language_dictionary.address_dialog_street,
                                    inputType: 'text',
                                    name: 'street_3',
                                    validations: [
                                        {
                                            name: 'serverError',
                                        },
                                    ],
                                }"
                                [group]="form?.get(field.name)"
                            ></ng-container>
                        </div>
                    </div>
                </div>
                <div class="flex flex-row gap-2">
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.address_dialog_building,
                                inputType: 'text',
                                name: 'building',
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        ></ng-container>
                    </div>
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'input',
                                label: appService.language_dictionary.address_dialog_apartment,
                                inputType: 'text',
                                name: 'apartment',
                                validations: [
                                    {
                                        name: 'serverError',
                                    },
                                ],
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                </div>
                <div class="flex flex-row basis-full gap-2">
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'checkbox',
                                label: appService.language_dictionary.system_including_additional_information,
                                name: 'including_additional_information',
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                    <div class="basis-full">
                        <ng-container
                            dynamic-field
                            [field]="{
                                type: 'checkbox',
                                label: appService.language_dictionary.system_exact_match,
                                name: 'exact_match',
                            }"
                            [group]="form?.get(field.name)"
                        >
                        </ng-container>
                    </div>
                </div>
            </div>
        </fui-card>
    </ng-container>
</ng-template>
